import $ from 'jquery'

let $logoLetters = []
const ignoreChars = [' ']

export function init() {
  // $logoLetters = $('#tivoli path');
  // pickNeonLetter($logoLetters, 25, 10000, 5000);

  $('[data-neon]').each((i, elem) => {
    const $elem = $(elem)
    const html = $elem
      .html()
      .split('')
      .reduce((text, letter) => text + (ignoreChars.indexOf(letter) >= 0 ? letter : '<span>' + letter + '</span>'), '')
    $elem.html(html)
    const $letters = $elem.find('span')
    $letters.addClass('neon-glow')
    pickNeonLetter($letters)
  })
}

function pickNeonLetter($letters, flickers = 30, interval = 2000, randomInterval = 3000) {
  const letter = Math.floor(Math.random() * $letters.length)
  const $letter = $($letters[letter])
  flicker($letter, flickers, true)
  setTimeout(() => pickNeonLetter($letters), Math.round(Math.random() * randomInterval) + interval)
}

function flicker($letter, counter = 0, on = false) {
  if (on && counter > 0) $letter.addClass('kill-glow')
  else $letter.removeClass('kill-glow')
  // $letter.css('filter', (on && counter > 0) ? 'none' : 'url("#glowfilter")');
  if (counter > 0) setTimeout(() => flicker($letter, counter - 1, !on), Math.floor(Math.random() * 100))
}
